import React from "react";
import "./ChantDatePicker.css";
import { DatePicker } from "antd";
import { Controller } from "react-hook-form";

const ChantDatePicker = ({
  label,
  helpText,
  control,
  name,
  required,
  rules,
  disabled,
  value,
  defaultValue,
  onChange: customOnChange,
  ...props
}) => {
  const handleChange = (date, dateString) => {
    if (customOnChange) {
      customOnChange(date, dateString);
    }
  };

  // If control and name are provided, use Controller pattern
  if (control && name) {
    return (
      <div className="chant-datepicker-container">
        {label && (
          <label className="chant-datepicker-label">
            {label} {required ? <span style={{ color: "red" }}>*</span> : null}
          </label>
        )}
        <div className="chant-datepicker-wrapper">
          <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => (
              <div>
                <DatePicker
                  {...field}
                  {...props}
                  status={error ? "error" : ""}
                  disabled={disabled}
                  onChange={(date, dateString) => {
                    // Call React Hook Form's onChange first
                    field.onChange(date);
                    // Then call custom onChange if provided
                    if (customOnChange) {
                      customOnChange(date, dateString);
                    }
                  }}
                />
                {error && (
                  <div className="chant-datepicker-error">{error.message}</div>
                )}
              </div>
            )}
          />
        </div>
        {helpText && <div className="chant-datepicker-help">{helpText}</div>}
      </div>
    );
  }

  // Otherwise, use the regular pattern for backward compatibility
  return (
    <div className="chant-datepicker-container">
      {label && (
        <label className="chant-datepicker-label">
          {label} {required ? <span style={{ color: "red" }}>*</span> : null}
        </label>
      )}
      <div className="chant-datepicker-wrapper">
        <DatePicker
          {...props}
          disabled={disabled}
          value={value}
          defaultValue={defaultValue}
          onChange={handleChange}
        />
      </div>
      {helpText && <div className="chant-datepicker-help">{helpText}</div>}
    </div>
  );
};

export default ChantDatePicker;
